<template>
  <em class="text-sm text-gray-500">Het ophalen van de data is niet gelukt. <br />Refresh de pagina of probeer het later opnieuw.</em>
</template>
